import PropTypes from 'prop-types';
import React from 'react';
import RuleCard from './RuleCard';
import ThresholdRow from './ThresholdRow';

// One detector under IF. It defines what counts as suspicious and nothing else — no action
// control, because what happens next is the single card under THEN.
const SignalRule = ({
  copy,
  rule,
  deferred,
  locked,
  busy,
  canAdminister,
  onToggle,
  onConfigChange,
}) => {
  const { key } = copy.threshold;

  return (
    <RuleCard
      ruleType={copy.ruleType}
      title={copy.title}
      icon={copy.icon}
      description={copy.description}
      badge={copy.badge}
      tooltip={copy.tooltip}
      enabled={rule.enabled}
      deferred={deferred}
      locked={locked}
      busy={busy}
      canAdminister={canAdminister}
      onToggle={onToggle}
      renderBody={() => (
        <ThresholdRow
          ruleType={copy.ruleType}
          threshold={copy.threshold}
          value={rule.config[key]}
          options={rule.options[key] || []}
          disabled={locked || !canAdminister || busy}
          onChange={(value) => onConfigChange(key, value)}
        />
      )}
    />
  );
};

SignalRule.propTypes = {
  copy: PropTypes.shape({
    ruleType: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    icon: PropTypes.string,
    description: PropTypes.string.isRequired,
    badge: PropTypes.string,
    tooltip: PropTypes.shape({ term: PropTypes.string, text: PropTypes.string }),
    threshold: PropTypes.shape({ key: PropTypes.string.isRequired }).isRequired,
  }).isRequired,
  rule: PropTypes.shape({
    enabled: PropTypes.bool,
    config: PropTypes.object,
    options: PropTypes.object,
  }).isRequired,
  deferred: PropTypes.bool,
  locked: PropTypes.bool,
  busy: PropTypes.bool,
  canAdminister: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  onConfigChange: PropTypes.func.isRequired,
};

SignalRule.defaultProps = { deferred: false, locked: false, busy: false, canAdminister: false };

export default SignalRule;
